import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function FeaturedArticles() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              {t('featuredArticles.title')}
            </h2>
            <p className="text-sm text-foreground-500">
              学习麻将规则、技巧与文化，提升你的麻将水平
            </p>
          </div>
          <Link
            to="/category/majiang-jiqiao"
            className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 whitespace-nowrap"
          >
            {t('featuredArticles.viewAll')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Link
            to="/article/guobiao-majiang-wanzheng-guize"
            className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300"
          >
            <div className="relative h-44 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20mahjong%20national%20standard%20competition%20scene%20with%20professional%20players%2C%20warm%20ambient%20light%2C%20traditional%20Chinese%20elements%2C%20clean%20minimalist%20composition%2C%20artistic%20photography&width=400&height=280&seq=article-guobiao-01&orientation=landscape"
                alt="国标麻将完整规则详解"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-3 mb-3">
                <span className="px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium">国标麻将</span>
                <span className="text-xs text-foreground-400">2026-08-05</span>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                国标麻将完整规则详解：从入门到精通
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                国标麻将是中国官方认可的竞赛麻将标准，包含81个番种。本文详细介绍国标麻将的完整规则、计分方式和常用策略。
              </p>
              <div className="mt-4 flex items-center gap-1 text-primary-600 text-sm font-medium">
                <span>{t('article.readMore')}</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </div>
          </Link>

          <Link
            to="/article/sichuan-majiang-xuezhan-dadi"
            className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300"
          >
            <div className="relative h-44 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Sichuan%20teahouse%20mahjong%20game%20atmosphere%20with%20players%20around%20table%2C%20traditional%20Chinese%20decor%2C%20warm%20soft%20lighting%2C%20cozy%20composition%2C%20artistic%20photography&width=400&height=280&seq=article-sichuan-01&orientation=landscape"
                alt="四川麻将血战到底"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-3 mb-3">
                <span className="px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium">四川麻将</span>
                <span className="text-xs text-foreground-400">2026-07-28</span>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                四川麻将血战到底：规则、技巧与实战心得
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                四川麻将以其独特的血战到底规则闻名全国。本文深度解析四川麻将的核心规则、缺一门策略以及实战中的制胜技巧。
              </p>
              <div className="mt-4 flex items-center gap-1 text-primary-600 text-sm font-medium">
                <span>{t('article.readMore')}</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </div>
          </Link>

          <Link
            to="/article/majiang-chuxuezhe-bibei-jiqiao"
            className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300"
          >
            <div className="relative h-44 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Closeup%20of%20mahjong%20tiles%20being%20arranged%20by%20hands%20on%20wooden%20table%2C%20learning%20and%20strategy%20concept%2C%20warm%20lighting%2C%20clean%20minimalist%20composition%2C%20artistic%20photography&width=400&height=280&seq=article-tips-01&orientation=landscape"
                alt="麻将初学者必备技巧"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-3 mb-3">
                <span className="px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium">麻将技巧</span>
                <span className="text-xs text-foreground-400">2026-07-15</span>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                麻将初学者必备技巧：五个让你快速提升的实用策略
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                刚学麻将总是输？本文分享五个实用麻将技巧，帮助初学者快速提升牌技，从菜鸟变身牌桌高手。
              </p>
              <div className="mt-4 flex items-center gap-1 text-primary-600 text-sm font-medium">
                <span>{t('article.readMore')}</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}